module.exports = __webpack_public_path__ + "static/media/2.645046fd.jpg";